import { Banner, Icon } from "@shopify/polaris"
import { ArrowDownMinor } from "@shopify/polaris-icons"
import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useGQL } from "../../hooks/useGQL.js"
import { countryCodes } from "../../utils/countryCodes.js"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"

export const GeolocationRedirectEntryPreview = ({
	countriesAndIpsToRedirect,
	redirectTo,
	maintainPath,
}) => {
	const [t] = useTranslation()
	const { state, dispatch } = useContext(GlobalStateContext)
	const gqlQuery = useGQL()

	const [shopDomain, setShopDomain] = useState(null)

	useEffect(() => {
		gqlQuery(`
				query {
					shop {
						primaryDomain {
							url
						}
				}
			}
		`)
			.then((res) => {
				if (res?.data?.shop?.primaryDomain?.url) {
					setShopDomain(res.data.shop.primaryDomain.url)
				}
			})
			.catch((err) => console.error(err))
	}, [])

	const countriesAndIpsToDisplay = countriesAndIpsToRedirect
		.map((countryOrIp) => {
			if (countryCodes[countryOrIp]) {
				return countryCodes[countryOrIp]
			} else {
				return countryOrIp
			}
		})
		.slice(0, 3)

	let redirectToUrl = null
	let shopDomainUrl = null

	try {
		redirectToUrl = new URL(redirectTo)
		shopDomainUrl = new URL(shopDomain)
	} catch (err) {
		console.error(err)
	}

	return (
		<>
			{redirectToUrl &&
				shopDomainUrl &&
				redirectToUrl.hostname.includes(shopDomainUrl.hostname) &&
				redirectToUrl.hostname !== shopDomainUrl.hostname && (
					<div style={{ marginBottom: "1rem" }}>
						<Banner status="warning">
							{t("protect.geolocation_redirect.preview_warning")}
						</Banner>
					</div>
				)}

			<div
				style={{
					padding: "1rem",
					background: "#f9f9f9",
					border: "1px solid #ccc",
					borderRadius: "0.5rem",
				}}
			>
				<h1
					style={{
						fontSize: "1rem",
						marginBottom: "1rem",
						fontWeight: "600",
					}}
				>
					{t("protect.geolocation_redirect.redirect_preview")}
				</h1>

				<p style={{ marginBottom: "1rem" }}>
					{t("protect.geolocation_redirect.users_from")}{" "}
					<b>{countriesAndIpsToDisplay.join(", ")}...</b>{" "}
					{t("protect.geolocation_redirect.will_be_redirected")}
				</p>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "0.5rem",
					}}
				>
					<div
						style={{
							padding: "0.5rem",
							background: "rgba(0,200,255,0.15)",
							border: "1px solid #ccc",
							borderRadius: "0.5rem",
							display: "flex",
							gap: "0.7rem",
						}}
					>
						<div
							style={{
								width: "12%",
								borderRight: "1px solid #aaa",
							}}
						>
							<p
								style={{
									fontWeight: "600",
									fontFamily: "monospace",
									color: "#555",
								}}
							>
								{t("protect.geolocation_redirect.from")}
							</p>
						</div>
						<div style={{ width: "88%" }}>
							<p>
								{shopDomain || state.shop}
								{maintainPath && "/products/my-product"}
							</p>
						</div>
					</div>

					<div>
						<Icon source={ArrowDownMinor} color="black" />
					</div>

					<div
						style={{
							padding: "0.5rem",
							background: "rgba(0,255,200,0.15)",
							border: "1px solid #ccc",
							borderRadius: "0.5rem",
							display: "flex",
							gap: "0.7rem",
						}}
					>
						<div
							style={{
								width: "12%",
								borderRight: "1px solid #aaa",
							}}
						>
							<p
								style={{
									fontWeight: "600",
									fontFamily: "monospace",
									color: "#555",
								}}
							>
								{t("protect.geolocation_redirect.to")}
							</p>
						</div>
						<div style={{ width: "88%" }}>
							<p>
								{redirectTo || "www.mystore.co.uk"}
								{maintainPath && "/products/my-product"}
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
